import React, { useState } from "react"

import { SearchButton, SearchInput } from "./SearchBar.styles"

import { FaSearch } from "react-icons/fa"

const SearchBar = ({ placeholder, onSearch, value, onChange }) => {
    const [internalSearchTerm, setInternalSearchTerm] = useState('')
    
   // uses controlled value if provided, otherwise uses internal state
    const searchTerm = value !== undefined ? value : internalSearchTerm;
    const setSearchTerm = onChange !== undefined ? onChange : setInternalSearchTerm;

    const handleSearch = () => {
        const trimmedSearch = searchTerm.trim();
        
        const numbersOnly = trimmedSearch.replace(/[^\d]/g, '');
        const isNumericSearch = /^\d+[\d.\-\s]*$/.test(trimmedSearch) && numbersOnly.length > 0;
        
        const search = isNumericSearch ? numbersOnly : trimmedSearch;
        
        onSearch(search);
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    }

    return (
        <div style={{paddingTop: '20px'}}>
            <SearchInput
                type='text'
                placeholder={placeholder}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={handleKeyDown}
            />
            <SearchButton onClick={handleSearch}>
                <FaSearch style={{ marginRight: '8px' }} />
                Buscar
            </SearchButton>
        </div>
    )
}

export default SearchBar